// src/features/tidsregistering/services/overenskomster.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/overenskomster';

export const overenskomsterAPI = {
  createOverenskomst: (data) =>
    apiClient.post(`${BASE}/`, data),

  getOverenskomst: (overenskomstId) =>
    apiClient.get(`${BASE}/${overenskomstId}`),

  listForDepartment: () =>
    apiClient.get(`${BASE}/department`),

  updateOverenskomst: (overenskomstId, data) =>
    apiClient.put(`${BASE}/${overenskomstId}`, data),

  deleteOverenskomst: (overenskomstId) =>
    apiClient.delete(`${BASE}/${overenskomstId}`),

  listForStaff: (staffMemberId) =>
    apiClient.get(`${BASE}/staff/${staffMemberId}`),

  assignStaff: (data) =>
    apiClient.post(`${BASE}/assign-staff`, data),

  seedDefaultOverenskomster: () =>
    apiClient.post(`${BASE}/seed`),

  listActiveAssignmentsForDepartment: () =>
    apiClient.get(`${BASE}/department/active-assignments`),
};
